import {joinPaths, truncatePleasantly} from '../utils/index'
import * as PATHS from '../utils/paths'
import { Link } from 'gatsby'
import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import {Header7, PBody1, PBody2} from "./type";
import {MARGIN_SIZE, MARGIN_SIZE_SM_DOWN, SMALL_DOWN_MEDIA_QUERY, XS_DOWN_MEDIA_QUERY} from "./constants";



const articleSnippetStyles = theme => ({
  root: {
    marginBottom: 48,
    breakInside: 'avoid',
    pageBreakInside: 'avoid',
    webkitColumnBreakInside: 'avoid',
    width: "100%",
    '&:hover': {
      // marginBottom: 0
      // mixBlendMode: "normal",
      textDecoration: "underline",
      textDecorationColor: "#E5E5E5",
    },
  },


  titleText: {
    marginBottom: 4,
    lineHeight: '32px',
    fontSize: 27,
    fontWeight: 600,
    letterSpacing: -.75
  },
  descriptionText: {
    lineHeight: '24px',
    fontSize: 16,
    marginBottom: 0
  },
  contentWrapper: {
    display: "flex",
    alignItems: "stretch",
    flexDirection: "column",
    rowGap: 24,

    // [SMALL_DOWN_MEDIA_QUERY]: {
    //   alignItems: "center",
    //   marginLeft: -MARGIN_SIZE_SM_DOWN,
    // },
    [SMALL_DOWN_MEDIA_QUERY]: {
      flexDirection: "row",
      columnGap: 24,
      alignItems: "start",
      // marginLeft: 0,
    }
  },
  textWrapper: {
    display: "flex",
    alignItems: "stretch",
    flexDirection: "column",
    rowGap: 6,

    [SMALL_DOWN_MEDIA_QUERY]: {
      display: "block",
      flex: "1 1 66%",
    },
  },
  imageWrapper: {
    width: "100%",
    height: 192,
    // height: "auto",
    background: "#F2F2F2",
    // height: "75%"
    // aspectRatio: 100/150,
    // border: "1px solid red",
    position: "relative",
    // display: "flex",
    // flexDirection: "column",
    overflow: "hidden",
    transition: "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    '&:hover': {
      // marginBottom: 0
      // mixBlendMode: "normal",
      background: "#ffffff",
    },
    [SMALL_DOWN_MEDIA_QUERY]: {
      flex: "1 1 33%",
      // height: "auto",
      height: 96,

    },

    [XS_DOWN_MEDIA_QUERY]: {
      flex: "1 1 33%",

    },

  },

  image: {
    mixBlendMode: "darken",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: "100%",
    height: "100%",


  },

})
const _ArticleSnippet2 = ({ title, path, node, classes, borderBgColor }) => {

  const description = truncatePleasantly(node.frontmatter.description,
    100, '...')

  const imageStyle =  {
    backgroundImage: `url('${joinPaths([PATHS.CDN, node.fields.collection, node.fields.slug, node.fields.slug.slice(0, node.fields.slug.length - 1) + "-preview.png"])}')`,
  }

  return (

      <div
          className={classes.root}
          style={{
          }}
      >
        <Link style={{
          boxShadow: `none`,
          textDecoration: 'none',
          color: 'inherit',
        }} to={path}>
          <div className={classes.contentWrapper}>
            <div className={classes.imageWrapper}>
              <div className={classes.image}
                   style={imageStyle}
              />
            </div>

            <div className={classes.textWrapper}>
              <Header7>
                {title}
              </Header7>
              <PBody2 style={{lineHeight: 1.24}}>
                {description}
              </PBody2>
            </div>
          </div>

        </Link>
      </div>)
}
export const ArticleSnippet = withStyles(articleSnippetStyles)(_ArticleSnippet2)